<template>
  <div
    v-if="inspirations"
    class="inspiration-wrapper flex md:min-h-360 bg-fixed bg-center bg-no-repeat bg-cover mb-8 mt-8 theme"
    :class="inspirations.themeCssClass"
  >
    <div class="inspiration-media w-full md:w-1/2 relative overflow-hidden pb-full sm:pb-9/16 md:pb-0">
      <Picture
        v-bind="inspirations.image"
        lazy
        img-class="top-0 left-0 h-full w-full object-cover absolute"
        width="150"
        height="150"
        :desktop="[1100,0]"
        :tablet="[900,0]"
      />
    </div>

    <div
      class="inspiration-content w-full md:w-1/2 md:flex md:flex-col md:justify-center overflow-hidden px-4 pt-2 pb-10 md:py-16 md:px-16 lg:px-24"
    >
      <div class="md:max-w-400 md:mx-auto animated-item">
        <h2 class="text-h2 mb-4">
          {{ inspirations.title }}
        </h2>
        <div class="mt-4">
          {{ inspirations.text }}
        </div>
        <a
          class="btn solid mt-8 md:mt-12"
          :href="inspirations.link.url"
          :target="inspirations.link.openInNewWindow ? '_blank' : '_self'"
          @click="trackClick(inspirations.title, inspirations.link.text)"
        >
          <span>{{ inspirations.link.text }}</span>
          <span class="icon-arrow-right-new text-4xs ml-2" />
          <span class="icon-arrow-left text-xs mr-2" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Picture from '@/components/Picture.vue'
import { onMounted } from 'vue'
import fadeInText from '@/components/FadeInAnimation'

export default {
  components: {
    Picture
  },
  props: {
    inspirations: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  setup() {
    const trackClick = (textVisualBlockTitle, clickText) => {
      window.dataLayer.push({
        event: 'textVisualBlockClick',
        textVisualBlockTitle,
        clickText,
        placement: 'product overview page'
      })
    }

    onMounted(() => {
      fadeInText('.animated-item')
    })

    return {
      trackClick
    }
  }
}
</script>
